<template>
  <div class="invite">
    <div class="nav-bar" :class="language">
      <span class="back-icon" @click="handelBack"></span>
      <span class="title">{{ $t('邀请好友') }}</span>
      <span class="right-text" @click="handelShowRule">{{
        $t('活动规则')
      }}</span>
    </div>
    <div class="invite-content">
      <div class="invite-btn" @click="handleInvite"></div>
    </div>
    <InviteList language="ug" :totalReward="totalReward" :myRanks="myRanks" />
    <van-popup v-model="showRule" round>
      <div class="rule-wrap">
        <div class="rule-title">{{ $t('活动规则') }}</div>
        <div class="rule-content">
          <p>
            {{ $t('1、每成功邀请1名好友注册安装，可获得最高188钻石奖励。') }}
          </p>
          <p>
            {{ $t('2、邀请的女性好友获得收益，平台将给与邀请者对应奖励。') }}
          </p>
          <p>{{ $t('注意事项：') }}</p>
          <p>
            {{
              $t(
                '*活动期间的中止、停止及续展由平台自行决定，活动停止后，新的邀请将不再享有邀请奖励。'
              )
            }}
          </p>
          <p>
            {{
              $t(
                '*若邀请方存在欺诈行为，如通过买卖手机号、个人信息等方式邀请，通过非法渠道和方法、脚本等方式获取邀请奖励，平台有权按照无效邀请处理的同时，违规方将遭到平台封禁处罚'
              )
            }}
          </p>
          <p>
            {{
              $t(
                '*请认真阅读并理解本规则，若您参与本次活动，均视为您已阅读并同意本规则，若您关于本活动有任何疑问，请您联系平台客服咨询。'
              )
            }}
          </p>
        </div>
        <div class="rule-btn" @click="showRule = false"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  appFunc_callExit,
  appFunc_callShareWeChat,
  appFunc_senToken
} from '@/utils/bridge'
import { apiGetinviteMyRanks } from '@/api'
import { debounce } from '@/utils/index'
import { CommonModule } from '@/store/modules/common'
import InviteList from './InviteList.vue'
import AES from 'crypto-js/aes'
import ECB from 'crypto-js/mode-ecb'
import utf8 from 'crypto-js/enc-utf8'

export default {
  components: {
    InviteList
  },
  data() {
    return {
      showRule: false,
      language: 'ug',
      myRanks: [],
      totalReward: 0
    }
  },
  async created() {
    CommonModule.setLanguage('zh')
    await this.getToken()
    this.getMyRanks()
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, '', document.URL)
      window.addEventListener('popstate', this.handelBack, false)
    }
    const { aplus_queue } = window
    aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        'enter_the_invitation_page',
        'CLK',
        {
          source: decodeURIComponent(this.$route.query.pageFrom) || ''
        }
      ]
    })
  },

  //页面销毁时，取消监听。否则其他vue路由页面也会被监听--物理返回键
  destroyed() {
    window.removeEventListener('popstate', this.handelBack, false)
  },
  methods: {
    siginUserId(userId) {
      try {
        const privateKey = 'a*ll&oi(d1ca^rd@'
        const keyBytes = utf8.parse(privateKey)
        const encrypt = AES.encrypt(`${userId}`, keyBytes, {
          mode: ECB
        })
        return encrypt.toString()
      } catch (error) {
        console.log(error)
        return ''
      }
    },

    // 微信登录回调
    handleSucceed(data) {
      console.log(data, '-----------------')
      const { tokenForJs, id } = JSON.parse(data)
      CommonModule.setToken(tokenForJs)
      CommonModule.setUserId(id)
      // 成功绑定
    },
    // 返回
    handelBack() {
      appFunc_callExit()
    },
    handelShowRule() {
      this.showRule = true
    },
    handleInvite: debounce(function() {
      console.log('-------------', CommonModule.token)
      const { aplus_queue } = window
      aplus_queue.push({
        action: 'aplus.record',
        arguments: ['Invite_friends', 'CLK']
      })
      if (!CommonModule.token) {
        CommonModule.login()
        return
      }
      const inviteCode = this.siginUserId(CommonModule.userId)
      console.log('邀请', inviteCode)

      if (inviteCode) {
        appFunc_callShareWeChat({
          title: '聊天交友？上青书',
          content: '优质单身男女都在青书',
          activityPageUrl: `${
            window.location.origin
          }/#/new-invite-login?inviteCode=${encodeURIComponent(inviteCode)}`,
          webpageUrl: 'http://www.allosoft.top'
        })
      }
    }),
    async getMyRanks() {
      const { code, data } = await apiGetinviteMyRanks(1)
      if (code === 1001) {
        this.totalReward = data.totalReward || 0
        this.myRanks = data.users || []
      }
      // this.myRanks = [
      //   {
      //     headUrl:
      //       'https://web.allosoft.top/h5/main/img/income-bg.076bd37c.png',
      //     id: 123,
      //     name: 'wangbadan',
      //     successTime: '2021-2-13 10:20'
      //   }
      // ]
    },
    async getToken() {
      const res = await appFunc_senToken()
      console.log(res, '/////////////')
      CommonModule.setUserId(res.id)
      CommonModule.setToken(res.tokenForJs)
      CommonModule.setUserPhone(res.mobile)
      CommonModule.setUserName(res.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.invite {
  padding: 44px 0 30px;
  background: #aef0ff;
  .nav-bar {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    color: #000000;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #ffffff;
    .back-icon {
      width: 30px;
      height: 30px;
      @include bg-image('icon_back');
      position: absolute;
      left: 4px;
      top: 8px;
    }
    .title {
      font-size: 16px;
      line-height: 44px;
    }
    .right-text {
      font-size: 14px;
      position: absolute;
      right: 12px;
      line-height: 44px;
    }
  }
  .invite-content {
    height: 505px;
    @include bg-image('newInvite/pic_ptjl@3x');
    overflow: hidden;
    margin-bottom: 28px;
    .invite-btn {
      width: 338px;
      height: 71px;
      margin: 426px 0 0 19px;
      @include bg-image('newInvite/pic_ljyq@3x');
    }
  }
  .rule-wrap {
    width: 322px;
    max-height: 90vh;
    // height: 322px;
    background-color: #fff;
    padding: 20px 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .rule-title {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      text-align: center;
      padding-bottom: 20px;
    }
    .rule-content {
      flex: 1;
      overflow: auto;
    }
    p {
      font-family: PingFang SC, PingFang SC;
      font-size: 14px;
      line-height: 20px;
      color: #5c5c5c;
      margin-bottom: 4px;
    }
    .rule-btn {
      flex-shrink: 0;
      width: 266px;
      height: 56px;
      margin-top: 12px;
      @include bg-image('newInvite/pic_ljyq@2x');
    }
  }
}
</style>
